export var scrollToActiveElement = function scrollToActiveElement(activeElementRef, scrollContainerRef) {
  var activeElement = activeElementRef.current;
  var scrollContainer = scrollContainerRef.current;

  if (activeElement && scrollContainer) {
    var activeElementTop = activeElement.offsetTop;
    var bottomOverflow = activeElementTop > scrollContainer.offsetHeight;

    if (bottomOverflow) {
      scrollContainer.scrollTop = activeElementTop + activeElement.offsetHeight;
      return;
    }

    var topOverflow = scrollContainer.scrollTop > activeElementTop;

    if (topOverflow) {
      scrollContainer.scrollTop = activeElement.offsetTop;
    }
  }
};